<template lang="pug">
div 
  v-btn(color='primary' data-test="c-item-submit" @click="submit" :loading="loading") Save
  v-dialog(v-model="dialog" @click:outside="hideDialog")
    v-card()
      v-card-title.headline Candidate with the same number
      v-card-text 
        p There is a candidate with the same number in the system. Are you sure you want to save?
        div(v-if="sameCandidate")
          v-text-field(label="Name" :value="sameCandidate.fullName" readonly)
          v-text-field(label="Birthday" :value="sameCandidate.candidateBirthday" readonly)
          v-text-field(label="Email" :value="sameCandidate.candidateEmail" readonly)
      v-card-actions
        slot(name="actions")
          v-spacer
          v-btn(color="error" text @click="hideDialog") cancel
          v-btn(color="success" text @click="update" :loading="loading") save
    
</template>

<script>
import Model from "../../core/candidates-reservation-model"
import errorsMixin from '@/mixins/errors.mixin';
import CandidateValidator from "../../core/models/validation/candidateValidator"

export default {
  mixins: [errorsMixin],
  inject: ['svc'],

  props: {
    model: Object,
    candidateNumberChanged: Boolean,
    updateRequests: Function,
    formErrors: Object,
  },
  data: () => ({
    dialog: false,
    loading: false,
    sameCandidate: null
  }),

  methods: {
    submit() {
      this.updateRequests()
      if (!new CandidateValidator(this.model, this.formErrors).validate() ) {
        this.$notify({text: 'Invalid fields', type: 'error'})
        return false;
      }
      if(!this.candidateNumberChanged) {
        this.update()
        return
      } 
      this.checkOnSameCandidate()
    },

    async checkOnSameCandidate() {
      this.loading = true
      try {
        let res = await this.svc().findByNumber(this.model.candidateNumber)
        this.loading = false
        if(!res.id) {
          this.update()
          return
        }
        this.sameCandidate = new Model(res)
        this.dialog = true
      } catch (error) {
        this.loading = false
        this.processError(error, {
          redirectName: this.$ROUTER_NAMES.LOGIN_EXERCISE })
      }
    },

    update() {
      this.hideDialog()
      this.$emit('submit')
    },

    hideDialog() {
      this.dialog = false
      this.sameCandidate = null
    },

    merge() {
      this.$emit('sameCandidateFinded', this.sameCandidate.ID)
      this.dialog = false
      this.sameCandidate = null
    },

  }
}
</script>